import tippy from "tippy.js";

const priceTooltips = document.querySelectorAll(".js-card-info__buy-cheaper");

if (priceTooltips && priceTooltips.length > 0) {
    for (const priceTooltip of priceTooltips) {
        tippy(priceTooltip, {
            arrow: true,
            placement: "top", // top, right, bottom, left
            trigger: "mouseenter click",
            interactive: true,

            allowHTML: true,
            hideOnClick: true,
            theme: "light",
            onCreate(instance) {
                const instanceContainer =
                    instance.reference.querySelector("[data-tooltip-content]");
                instanceContainer
                    .querySelectorAll("a")
                    .forEach((elem) => elem.addEventListener("click", instance.hide));
                instance.setContent(instanceContainer);
            },
            appendTo: () => document.body,
        });
    }
}
